import type { RequestCard } from '../../../lib/types'
import { ItWorksActions } from './ItWorksActions'
import { ItWorksFinalChange, ItWorksLinesPanel } from './ItWorksLinesPanel'

/**
 * IT-работы в теле карточки (над вкладками): черновик (открыть / удалить), «Сумма изменена на
 * доработке» финальному утверждающему и решения по своим строкам модулей (есть строки в
 * canDecideLines). Монтируется одной строкой в ProcessWorkflow — его рисуют и дровер, и
 * страница заявки. Другим типам — ничего.
 */
export function ItWorksWorkflow({ card, onDone }: { card?: RequestCard; onDone: () => void }) {
  if (card?.type !== 'IT_WORKS') return null
  return (
    <>
      <ItWorksActions key={card.id} card={card} onDone={onDone} />
      <ItWorksFinalChange card={card} />
      {!!card.itWorks?.canDecideLines.length && <ItWorksLinesPanel key={`${card.id}:lines`} card={card} />}
    </>
  )
}
